<script setup lang="ts">
import { ButtonSeverity, TuButton } from "@tinyurldev/tu-ui-vue";

import useTranslation from "@Resources/js/composables/useTranslation";
import PlaceHolderImage from "@Images/analytics/block3.png";

//
// Setup
const { __ } = useTranslation();

//
// Emit
interface Events {
  (e: "enable-stats"): void;
}

const emit = defineEmits<Events>();
</script>

<template>
  <div class="stats-disabled-overlay _stats_disabled">
    <h2 class="stats-disabled-overlay__title">
      {{ __("organization_dashboard.stats_disabled.title") }}
    </h2>
    <p class="stats-disabled-overlay__message">
      {{ __("organization_dashboard.stats_disabled.message") }}
    </p>
    <div class="stats-disabled-overlay__image">
      <img :src="PlaceHolderImage">
    </div>
    <TuButton
      class="_enable_stats"
      :label="__('organization_dashboard.stats_disabled.button_label')"
      :severity="ButtonSeverity.SECONDARY"
      @click="emit('enable-stats')"
    />
  </div>
</template>


<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;
@use "@tinyurldev/tu-ui-vue/scss/settings/position.scss" as position;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;

.stats-disabled-overlay {
  display: flex;
  flex-flow: column;
  gap: spacing.$xxxs;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  background-color: color.$background-primary;

  &__title {
    font-size: typography.$h2-font-size;
    line-height: typography.$h2-line-height;
    font-weight: typography.$font-weight-bold;
  }

  &__message {
    font-size: typography.$base-font-size;
    line-height: typography.$base-line-height;
    font-weight: typography.$font-weight-medium;
  }

  &__image {
    width: 100%;
    max-width: 600px;
  }

  &__title,
  &__message {
    margin: 0;

    text-align: center;
  }
}
</style>